import "./App.css";
import KishuSelector from "./KishuSelector";
import Kishu from "./Kishu.js";
import Breeder from "./Breeder";
import { useState } from "react";

function App() {
  const [dad, setDad] = useState("");
  const [mom, setMom] = useState("");
  const [baby, setBaby] = useState("");

  const updateCurrentParent = (parent, kishuJson) => {
    if (parent === "dad") setDad(kishuJson);
    else setMom(kishuJson);
  };

  const createBabyKishu = (kishuJson) => {
    //console.log("Baby Kishu: ", kishuJson);
    setBaby(kishuJson);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-6 col-md-3">
          <KishuSelector
            updateParent={updateCurrentParent}
            gender={"male"}
            currParent={dad}
          ></KishuSelector>
          <Kishu gender={"male"} json={dad} />
        </div>
        <div className="col-sm-6 col-md-3">
          <KishuSelector
            updateParent={updateCurrentParent}
            gender={"female"}
            currParent={mom}
          ></KishuSelector>
          <Kishu gender={"female"} json={mom} />
        </div>
        <div className="col-sm-12 col-md-6">
          <Breeder dad={dad} mom={mom} updateBabyKishu={createBabyKishu} />
        </div>
      </div>
      <div className="col-sm-6 col-md-3">
        <Kishu
          gender={
            baby["description"]
              ? baby["description"][0] === "M"
                ? "male"
                : "female"
              : ""
          }
          json={baby ? baby : ""}
        />
      </div>
    </div>
  );
}

export default App;
